export const StageDuration: Record<number | "DEFAULT", number> = {
  0: 12, // adjusted for treasure town theme
  1: 12,
  2: 12,
  3: 12,
  5: 20,
  8: 20,
  9: 20,
  10: 25,
  11: 20,
  15: 20,
  19: 20,
  20: 25,
  DEFAULT: 15
}
export const FIGHTING_PHASE_DURATION = 30000
export const ITEM_CAROUSEL_BASE_DURATION = 12000
export const PORTAL_CAROUSEL_BASE_DURATION = 16000

export const ItemCarouselStages = [4, 12, 17, 22, 27, 34]
export const AdditionalPicksStages = [5, 8, 11]
export const PortalCarouselStages = [0, 10, 20]
